import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import Switch from '@material-ui/core/Switch';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import FormControl from '@material-ui/core/FormControl';

export const EditEducationalContentMutation = gql`
  mutation editEducationalContent(
    $id: ID!
    $title: String
    $description: String
    $visible: Boolean
    $content_type: String
    $thumbnail_url: String
    $asset_url: String
    $embed_code: String
    $locale: String
    $category: String
  ) {
    editEducationalContent(
      id: $id
      title: $title
      description: $description
      visible: $visible
      content_type: $content_type
      thumbnail_url: $thumbnail_url
      asset_url: $asset_url
      embed_code: $embed_code
      locale: $locale
      category: $category
    )
  }
`;

class EditEducationalContent extends React.Component {
  constructor(props) {
    super(props);
    const { educationalContent } = this.props;
    this.state = {
      id: educationalContent.id,
      title: educationalContent.title || '',
      description: educationalContent.description || '',
      visible: !!educationalContent.visible,
      contentType: educationalContent.content_type || educationalContent.contentType || 'document',
      thumbnailUrl: educationalContent.thumbnail_url || educationalContent.thumbnailUrl || '',
      assetUrl: educationalContent.asset_url || educationalContent.assetUrl || '',
      embedCode: educationalContent.embed_code || educationalContent.embedCode || '',
      locale: educationalContent.locale || 'en',
      category: educationalContent.category || '',
      mdBody: educationalContent.mdBody || educationalContent.md_body || '',
      taskTemplateKey: Array.isArray(educationalContent.action_plan_task_keys)
        ? educationalContent.action_plan_task_keys
        : (educationalContent.taskTemplateKey ? [educationalContent.taskTemplateKey] : []),
      taskTemplates: [],
      previewOpen: false,
    };
  }

  UNSAFE_componentWillReceiveProps = nextProps => {
    const { educationalContent } = this.props;
    if (nextProps.educationalContent.id !== educationalContent.id) {
      this.setState({
        id: nextProps.educationalContent.id,
        title: nextProps.educationalContent.title || '',
        description: nextProps.educationalContent.description || '',
        visible: !!nextProps.educationalContent.visible,
        contentType: nextProps.educationalContent.content_type || nextProps.educationalContent.contentType || this.state.contentType,
        thumbnailUrl: nextProps.educationalContent.thumbnail_url || nextProps.educationalContent.thumbnailUrl || '',
        assetUrl: nextProps.educationalContent.asset_url || nextProps.educationalContent.assetUrl || '',
        embedCode: nextProps.educationalContent.embed_code || nextProps.educationalContent.embedCode || '',
        locale: nextProps.educationalContent.locale || 'en',
        category: nextProps.educationalContent.category || '',
        mdBody: nextProps.educationalContent.mdBody || nextProps.educationalContent.md_body || '',
      });

      // Fetch fresh md_body for the newly selected item
      const id = nextProps.educationalContent.id;
      if (id) {
        fetch(`/educational_contents/${id}.json`, { credentials: 'same-origin' })
          .then(r => (r.ok ? r.json() : null))
          .then(data => {
            if (data && typeof data.md_body === 'string') {
              this.setState({
                mdBody: data.md_body,
                contentType: data.content_type || this.state.contentType,
                taskTemplateKey: Array.isArray(data.action_plan_task_keys) ? data.action_plan_task_keys : []
              });
            }
          })
          .catch(() => {});
      }
    }
  };

  handleChange = (field, value) => {
    this.setState({ [field]: value });
  };

  componentDidMount() {
    // Always fetch templates
    fetch('/task_templates.json', { credentials: 'same-origin' })
      .then(r => (r.ok ? r.json() : []))
      .then(json => {
        const arr = Array.isArray(json) ? json : (Array.isArray(json.task_templates) ? json.task_templates : []);
        this.setState({ taskTemplates: arr });
        window.__lastECState = { taskTemplates: arr, taskTemplateKey: this.state.taskTemplateKey };
        window.lastECState = window.__lastECState;
      })
      .catch(() => {});

    const { educationalContent } = this.props;
    if (!educationalContent || !educationalContent.id) return;
    // Fetch MD body via JSON endpoint to ensure we have latest server value
    fetch(`/educational_contents/${educationalContent.id}.json`, { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (data && typeof data.md_body === 'string') {
          this.setState({
            mdBody: data.md_body,
            contentType: data.content_type || this.state.contentType,
            taskTemplateKey: Array.isArray(data.action_plan_task_keys) ? data.action_plan_task_keys : (this.state.taskTemplateKey || [])
          });
        }
      })
      .catch(() => {});
  }

  render() {
    const {
      mutate,
      refetch,
      openEdit,
      educationalContent,
      educationalContents,
      handleClickEdit,
      updateEducationalContent,
    } = this.props;
    const { id, title, description, visible, contentType, thumbnailUrl,
       assetUrl, embedCode, locale, category, mdBody, previewOpen, taskTemplateKey, taskTemplates } = this.state;
    return (
      <div>
        <Dialog
          open={openEdit}
          onClose={() => handleClickEdit({})}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">Edit Educational Content</DialogTitle>
          <DialogContent>
            <TextField
              label="Title"
              fullWidth
              value={title}
              onChange={e => {
                this.handleChange('title', e.target.value);
              }}>
              {title}
            </TextField>
            <TextField
              label="Description"
              fullWidth
              value={description}
              onChange={e => {
                this.handleChange('description', e.target.value);
              }}>
              {description}
            </TextField>
            <InputLabel id="demo-simple-select-label">Visible?</InputLabel>
            <Switch
              checked={visible}
              onChange={e => {
                this.handleChange('visible', e.target.checked);
              }}
              color="primary"
              name="checkedB"
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
            <InputLabel id="demo-simple-select-label">Content Type</InputLabel>
            <Select
              fullWidth
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={contentType}
              onChange={e => {
                this.handleChange('contentType', e.target.value);
              }}>
              <MenuItem value="video">Video</MenuItem>
              <MenuItem value="document">Document</MenuItem>
              <MenuItem value="iframe">iFrame</MenuItem>
              <MenuItem value="markdown">Markdown</MenuItem>
            </Select>
            {contentType === 'markdown' && (
              <TextField
                label="Markdown Body"
                fullWidth
                multiline
                rows={18}
                value={mdBody}
                onChange={e => this.handleChange('mdBody', e.target.value)}>
                {mdBody}
              </TextField>
            )}
            <TextField
              label="Thumbnail URL"
              fullWidth
              value={thumbnailUrl}
              onChange={e => {
                this.handleChange('thumbnailUrl', e.target.value);
              }}>
              {thumbnailUrl}
            </TextField>
            {contentType !== 'iframe' && (
              <TextField
                label="Asset URL"
                fullWidth
                value={assetUrl}
                onChange={e => {
                  this.handleChange('assetUrl', e.target.value);
                }}>
                {assetUrl}
              </TextField>
            )}
            {contentType !== 'document' &&
              contentType !== 'video' && (
                <TextField
                  label="Embed Code"
                  fullWidth
                  value={embedCode}
                  onChange={e => {
                    this.handleChange('embedCode', e.target.value);
                  }}>
                  {embedCode}
                </TextField>
              )}
            <TextField
              label="Category"
              fullWidth
              value={category}
              onChange={e => {
                this.handleChange('category', e.target.value);
              }}>
              {category}
            </TextField>
            <FormControl fullWidth>
              <InputLabel shrink={true} htmlFor="tpl-select-native">Task Templates</InputLabel>
              <Select
                native
                multiple
                inputProps={{ id: 'tpl-select-native' }}
                key={`tpl-select-native-${taskTemplates.length}`}
                value={Array.isArray(taskTemplateKey) ? taskTemplateKey : (taskTemplateKey ? [taskTemplateKey] : [])}
                onChange={e => {
                  const opts = Array.from(e.target.options || []).filter(o => o.selected).map(o => o.value);
                  this.handleChange('taskTemplateKey', opts);
                }}
                style={{ backgroundColor: '#ffffff', color: '#111111' }}
                inputProps={{ size: 8 }}
              >
                {(taskTemplates || []).map(t => (
                  <option key={t.key} value={t.key}>{t.title || t.key}</option>
                ))}
              </Select>
              <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>{(taskTemplates || []).length} templates loaded</div>
            </FormControl>
            <InputLabel id="demo-simple-select-label">Locale</InputLabel>
            <Select
              fullWidth
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={locale}
              onChange={e => {
                this.handleChange('locale', e.target.value);
              }}>
              <MenuItem value="en">English</MenuItem>
              <MenuItem value="fr">French</MenuItem>
            </Select>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleClickEdit()} color="primary">
              Cancel
            </Button>
            {contentType === 'markdown' && (
              <Button onClick={() => this.setState({ previewOpen: true })} color="default">
                Preview
              </Button>
            )}
            <IconButton
              color="secondary"
              onClick={() => {
                mutate({
                  variables: {
                    id,
                    title,
                    description,
                    visible,
                    content_type: contentType,
                    thumbnail_url: thumbnailUrl,
                    asset_url: assetUrl,
                    embed_code: embedCode,
                    locale,
                    category,
                    action_plan_task_keys: Array.isArray(taskTemplateKey) ? taskTemplateKey : (taskTemplateKey ? [taskTemplateKey] : []),
                  },
                }).then(response => {
                  if (response.data.editEducationalContent) {
                    updateEducationalContent({
                      ...educationalContents.find(e => e.id === educationalContent.id),
                      ...this.state,
                    });
                    refetch();
                  }
                  handleClickEdit();
                });
              }}>
              Save
            </IconButton>
          </DialogActions>
        </Dialog>
        <Dialog open={previewOpen} onClose={() => this.setState({ previewOpen: false })} fullWidth maxWidth="md">
          <DialogTitle>Preview</DialogTitle>
          <DialogContent>
            <div style={{ padding: 8 }}>
              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {mdBody || ''}
              </ReactMarkdown>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ previewOpen: false })} color="primary">Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

EditEducationalContent.propTypes = {
  mutate: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
  openEdit: PropTypes.bool,
  educationalContent: PropTypes.object,
  educationalContents: PropTypes.array,
  handleClickEdit: PropTypes.bool,
  updateEducationalContent: PropTypes.func.isRequired,
};

EditEducationalContent.defaultProps = {
  openEdit: false,
  handleClickEdit: false,
  educationalContent: {},
  educationalContents: [],
};

export default graphql(EditEducationalContentMutation)(EditEducationalContent);
